import { $vars } from '../../config/vars';
import { $log, xavis_experiments } from '../y/debug';
import { $location, YLocationParams, YScrollState } from '../y/location';
import { $storage } from '../y/storage';
import { uiAnimate } from './animate';
import { $color } from './color';
import { UIMenuHeader, UIMenuHeaderOptions } from './component/menu-bar';
import { $el } from './elements';
import { UIMenu } from './menu';
import { UIScreen } from './screen';
import { uiCleanupTransition, uiSetupTransition } from './transition';
import { UIRect, UIValue } from './types';
import { UIViewAddSpec, UIViewSpec } from './view';

// set crumbs(crumbs: UIValue[] | undefined)
// {
//     if(crumbs) {
//         if(this._crumbs) {
//             this._crumbs.crumbs = crumbs;
//         } else {
//             this._crumbs = new UIBreadCrumbs(crumbs);
//             this._crumbs.on_option = (k) => { this.on_crumbs && this.on_crumbs(k); };

//             // if(xavis_experiments) {
//             //     const c_elem = this._crumbs;
//             //     conost t_elem = this.top_bar!;
//             //     const b_elem = this.bottom_bar!;
//             //     c_elem.style.position = 'absolute';
//             //     c_elem.style.top = '54px';
//             //     c_elem.style.opacity = '0';
//             //     t_elem.style.position = 'absolute';
//             //     t_elem.style.top = '0';
//             //     b_elem.style.position = 'absolute';
//             //     b_elem.style.position = '54px';
//             //     animate([{
//             //         what: c_elem,
//             //         style: 'opacity',
//             //         from: 0,
//             //         to: 1,
//             //         duration: 0.3
//             //     },{
//             //         what: c_elem,
//             //         style: 'top',
//             //         from: 54,
//             //         to: 0,
//             //         duration: 0.3
//             //     }, {
//             //         what: t_elem,
//             //         style: 'opacity',
//             //         from: 1,
//             //         to: 0,
//             //         duration: 0.3
//             //     }, {
//             //         what: b_elem,
//             //         style: 'opacity',
//             //         from: 1,
//             //         to: 0,
//             //         duration: 0.3
//             //     }, {
//             //         what: b_elem,
//             //         style: 'top',
//             //         from: 54,
//             //         to: 0,
//             //         duration: 0.3
//             //     }], () => {
//             //         c_elem.style.opacity = '';
//             //         c_elem.style.position = '';
//             //         t_elem.style.position = '';
//             //         b_elem.style.position = '';
//             //         this.top_bar!.hide();
//             //         this.bottom_bar!.hide();
//             //         b_elem.style.opacity = '';
//             //         t_elem.style.opacity = '';
//             //     });
//             // } else {
//                 this.top_bar && this.top_bar.hide();
//                 this.bottom_bar && this.bottom_bar.hide();
//             // }

//             this.add(this._crumbs);
//         }

//         document.body.classList.remove('double-menu');
//     } else if(this._crumbs) {
//         this.remove(this._crumbs);
//         this.top_bar && this.top_bar.show();
//         this.bottom_bar && this.bottom_bar.show();
//         this._crumbs.on_option = undefined; // TODO: check if it's necessary to avoid leak!!!
//         this._crumbs = undefined;

//         if(this.bottom_bar)
//             document.body.classList.add('double-menu');
//     }





// updateState()
// {
//     this._cur_screen && this._cur_screen.on_update_menu && this._cur_screen.on_update_menu(this._cur_location, this._menu_header);
// }

// saveScroll()
// {
//     const page = this._cur_subpage || this._cur_page || this._cur_screen;

//     if(page) {
//         page.saved_scroll = window.scrollY;
//         if(this._cur_view && this._cur_view.onSaveNavigationState)
//             page.saved_state = this._cur_view.onSaveNavigationState();
//     }
// }
// }

declare global {
    interface Window {
        loading_cover_animating?: boolean;
        loading_cover_done?: boolean;
        on_loading_cover_done?: () => void;
    }
}

export namespace $composer {
    const banner = $el.DIV('ui-banner c-dark');
    banner.ui_hide();
    const header = new UIMenuHeader();
    header.on_crumbs = k => { $location.popTo(k) };
    header.ui_hide();
    const main = $el.create('main', 'x-context', [banner, header]);
    document.body.ui_add(main);

    let current_screen: UIScreen;
    let header_visible = false;
    let strut: UIRect = [0, 0, 0, 0];
    let mobile_strut: UIRect = [0, 0, 0, 0];

    function showMenu(menu?: UIMenu, options?: UIMenuHeaderOptions, crumbs?: UIValue<number>[]) {
        if(menu || crumbs) {
            header.ui_show();
            header.setMenu(menu, options);
            header.setCrumbs(crumbs, options);
            header_visible = true;
        } else {
            header.ui_hide();
            header_visible = false;
        }
    }

    function recalcStrut() {
        strut = header_visible ? header.strut : [0, 0, 0, 0];
        mobile_strut = header_visible ? header.mobile_strut : [0, 0, 0, 0];

        if(!banner.ui_hidden) {
            strut[1] += 44;
            mobile_strut[1] += 44;
        }

        main.style.setProperty('--ui-strut-l', `${strut[0]}px`);
        main.style.setProperty('--ui-strut-t', `${strut[1]}px`);
        main.style.setProperty('--ui-strut-r', `${strut[2]}px`);
        main.style.setProperty('--ui-strut-b', `${strut[3]}px`);

        main.style.setProperty('--ui-strut-ml', `${mobile_strut[0]}px`);
        main.style.setProperty('--ui-strut-mt', `${mobile_strut[1]}px`);
        main.style.setProperty('--ui-strut-mr', `${mobile_strut[2]}px`);
        main.style.setProperty('--ui-strut-mb', `${mobile_strut[3]}px`);
    }

    // function _doTransition(from: UIScreen, to: UIScreen) 
    // {
    //     history.scrollRestoration = 'manual';

    //     const from_elem = from.ui_elem;
    //     const to_elem = to.ui_elem;

    //     document.body.style.height = document.body.scrollHeight+'px';

    //     const offset = -window.scrollY;
    //     from_elem.style.setProperty('--transition-scroll', offset+'px');
    //     from_elem.classList.add('f-transitioning-out');

    //     requestAnimationFrame(() => {
    //         window.scrollTo(0,0);
    //         const animations: UIAnimation[] = [{ what: to, animation: 'transition-in', duration: 0.25, easing: 'ease-out' }];

    //         // const from_content = from_elem.querySelector('.r-content');
    //         // if(from_content)
    //         //     animations.push({ what: from_content as HTMLElement, animation: 'transition-out', duration: 0.25, easing: 'ease-out', ignore_end: true })

    //         animate(animations, () => {
    //             from.onViewDidDisappear && from.onViewDidDisappear();
    //             from.remove();
    //         })

    //         this.ui_add(to);
    //         document.body.style.height = '';
    //     });
    // }

    // export function newShow(entry: UINavigationEntry) {
    //     const new_screen = entry.screen;

    //     showMenu(entry.menu, some_options_field, crumbs);

    // main.style.setProperty('--ui-strut-l', `${strut[0]}px`);
    // main.style.setProperty('--ui-strut-t', `${strut[1]}px`);
    // main.style.setProperty('--ui-strut-r', `${strut[2]}px`);
    // main.style.setProperty('--ui-strut-b', `${strut[3]}px`);

    // main.style.setProperty('--ui-strut-ml', `${mobile_strut[0]}px`);
    // main.style.setProperty('--ui-strut-mt', `${mobile_strut[1]}px`);
    // main.style.setProperty('--ui-strut-mr', `${mobile_strut[2]}px`);
    // main.style.setProperty('--ui-strut-mb', `${mobile_strut[3]}px`);

    //     if(new_screen != old_screen) {
    //         this._screen = new_screen;

    //         if(old_screen) {
    //             this._doTransition(old_screen, new_screen)
    //         } else {
    //             this.ui_add(new_screen);
    //         }
    //     }

    //     return new_screen;
    // }

    let has_removed_cover = false;

    const loaded = new Promise<void>((resolve, _reject) => {
        window.addEventListener('load', () => {
            if(window.loading_cover_animating && !window.loading_cover_done)
                window.on_loading_cover_done = resolve;
            else
                resolve();
        });
    });

    export function removeLoadingCover() {
        loaded.then(() => {
            const cover = document.getElementById('loading-cover');
            if(cover) {
                uiAnimate([{ what: cover, animation: 'fade-out', duration: 0.4 }], () => {
                    cover.parentElement!.removeChild(cover);
                });
            }
        });
        has_removed_cover = true;
    }

    export let current_transition: YLocationParams | undefined;

    export function show(screen: UIScreen, scroll?: YScrollState, menu?: UIMenu, menu_options?: UIMenuHeaderOptions, transition_params?: YLocationParams, back?: boolean, reload?: boolean, reappear?: boolean) {
        if(!has_removed_cover)
            removeLoadingCover();

        const src_screens: UIScreen[] = [];
        const dst_screens: UIScreen[] = [];

        let materialize_promise: Promise<void> | void | undefined;

        transition_params = transition_params ? { ...transition_params } : {};

        if(screen != current_screen) {
            if(current_screen) {
                src_screens.push(current_screen);

                if(xavis_experiments) {
                    let src_params = current_screen.onWillTransitionTo?.(screen, transition_params);
                    if(src_params)
                        Object.assign(transition_params, src_params);
                    const dst_params = screen.onWillTransitionFrom?.(current_screen, transition_params);
                    if(dst_params)
                        Object.assign(transition_params, dst_params);
                }
            }

            current_screen = screen;
            current_transition = transition_params;
            materialize_promise = current_screen.materialize();
            dst_screens.push(screen);
        }

        const updateDOM = () => {
            for(const s of src_screens) {
                s.remove();
                s.onViewDidDisappear?.();
                if(!back && !reload && !$location.manual_scroll)
                    window.scrollTo(0, 0);
            }
            showMenu(menu, menu_options, $location.getCrumbs());
            recalcStrut();
            for(const s of dst_screens) {
                main.ui_add(s);
                if($location.manual_scroll) {
                    if(scroll && typeof scroll == 'object') {
                        if(scroll.root)
                            window.scrollTo(scroll.root[0], scroll.root[1]);

                        for(const v of screen.ui_elem.getElementsByClassName('x-scroll-id')) {
                            if(v.ui_scroll_id) {
                                const scroll_state = scroll[v.ui_scroll_id];
                                if(scroll_state && (scroll_state[0] || scroll_state[1]))
                                    v.scrollTo(scroll_state[0], scroll_state[1]);
                            }
                        }
                    } else {
                        window.scrollTo(0, 0);
                    }
                }
                if(reappear)
                    s.onViewDidReappear?.();
            }
        }

        //mmm if we don't add the transitions till inside startViewTransition, then they're not applied to the source. if we do it outside, the dst might not be done
        if(xavis_experiments && document.startViewTransition && src_screens.length) {
            uiSetupTransition(src_screens, 'src');

            let dst_views: Record<string, HTMLElement> | undefined;

            const transition = document.startViewTransition(() => {
                if(materialize_promise instanceof Promise) {
                    return materialize_promise.then(() => {
                        dst_views = uiSetupTransition(dst_screens, 'dst');
                        updateDOM();
                    });
                } else {
                    dst_views = uiSetupTransition(dst_screens, 'dst');
                    updateDOM();
                }
                return;
            });
            transition.finished.then(() => {
                uiCleanupTransition(dst_views);
                current_transition = undefined;
                updateTitlebarColor();
            });
        } else {
            updateDOM();
            updateTitlebarColor();
        }

        updateTitle();
    }

    export function replaceScreen(screen: UIScreen) {
        show(screen);
    }

    export function isCurrentScreen(screen: UIScreen) {
        return screen == current_screen;
    }

    export function updateTitle() {
        const title = current_screen?.doc_title;
        if(title)
            document.title = title;
    }

    let titlebar_color: string | undefined;

    export function updateTitlebarColor() {
        if(!xavis_experiments)
            return;

        let new_color = current_screen?.titlebar_color;
        if(!new_color || !$color.maybe(new_color))
            new_color = $vars.titlebar_color;
        if(new_color != titlebar_color) {
            titlebar_color = new_color;
            const meta = document.head.querySelector('meta[name=theme-color]');
            meta?.setAttribute('content', new_color);
        }
    }

    export function canNavigate() {
        return (current_screen?.onViewWillDisappear) ? current_screen.onViewWillDisappear() : true;
    }

    export function addBGLayer(layer: UIViewSpec) {
        layer.classList.add('ui-bg-layer');
        document.body.ui_prepend(layer);
    }

    export function addBanner(content: UIViewAddSpec) {
        banner.ui_empty(content);
        banner.ui_show();
        header.setBannerHeight(44);
        recalcStrut();
    }

    export function removeBanner() {
        banner.ui_empty();
        banner.ui_hide();
        header.setBannerHeight(0);
        recalcStrut();
    }

    window.onbeforeunload = () => {
        const ret = current_screen?.onWillUnload?.() || undefined;
        $storage.commitPreferences();
        return ret;
    };
}

$log('app', 'initializing composer');
